export class JoinTodayModel {
  uuid?: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword?: string;
  orgUuid?: string;
  invitationToken?: string;
  isVerificationSent?: boolean;
  isAgreementChecked?: boolean;
  isEmailOrTokenAbsent?: boolean;
  isUserJoinedSuccessfully?: boolean;
  // Add more fields as needed

  constructor(
    uuid = "",
    firstName = "",
    lastName = "",
    email = "",
    password = "",
    confirmPassword = "",
    orgUuid = "",
    invitationToken = "",
    isVerificationSent = false,
    isAgreementChecked = false,
    isEmailOrTokenAbsent = false,
    isUserJoinedSuccessfully = false
  ) {
    this.uuid = uuid;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.password = password;
    this.confirmPassword = confirmPassword;
    this.orgUuid = orgUuid;
    this.invitationToken = invitationToken;
    this.isVerificationSent = isVerificationSent;
    this.isAgreementChecked = isAgreementChecked;
    this.isEmailOrTokenAbsent = isEmailOrTokenAbsent;
    this.isUserJoinedSuccessfully = isUserJoinedSuccessfully;
  }
}
